/** @jsx jsx */
import { jsx } from '@emotion/react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography2, VisuallyHidden } from '@coursera/cds-core';

import _t from 'i18n!nls/browse-common';

type Props = {
  medianSalary: number;
  currencyCode: string;
  emphasis: boolean;
};

const Salary = (props: Props) => {
  const { medianSalary, currencyCode, emphasis = true } = props;

  const salary = (
    <FormattedNumber
      value={medianSalary}
      // eslint-disable-next-line react/style-prop-object
      style="currency"
      currency={currencyCode}
      maximumFractionDigits={0}
      minimumFractionDigits={0}
    />
  );

  return (
    <Typography2 data-testid="median-salary" variant="bodySecondary" color="supportText" component="p">
      <VisuallyHidden component="span">{_t('This role has a ')}</VisuallyHidden>
      <FormattedMessage
        message={_t('{medianSalary} median salary ¹')}
        medianSalary={
          emphasis ? (
            <Typography2 data-testid="median-salary" variant="subtitleSmall" color="body" component="span">
              {salary}
            </Typography2>
          ) : (
            salary
          )
        }
      />
      <VisuallyHidden component="span">.</VisuallyHidden>
    </Typography2>
  );
};

export default Salary;
